import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@interfaces/rootState';
import { UserProfilePrimaryPracticeSelectorId } from '@store/selectors/UserProfileSelector';
import useCollection from '@utilities/hooks/useCollection/useCollection';
import { Surgeon } from '@data/surgeon/Surgeon';
import { ENDPOINT_ALL_SURGEONS } from '@utilities/apiConstants';
import { getFormattedName } from '@utilities/commonFunction';

export const useGetSurgeonOptionsByPractice = () => {
	const practiceId = useSelector<RootState, string>(UserProfilePrimaryPracticeSelectorId);
	const surgeons = useCollection<Surgeon>(ENDPOINT_ALL_SURGEONS + practiceId, { shouldDisableLoadIndicator: true });

	return React.useMemo(() => {
		return surgeons
			.map((surgeon) => {
				const formattedName = getFormattedName(surgeon);
				return {
					label: formattedName,
					value: surgeon.id,
				};
			})
			.sort(({ label: aLabel }, { label: bLabel }) => aLabel.localeCompare(bLabel));
	}, [surgeons]);
};
